import { render, staticRenderFns } from "./shouhufooter.vue?vue&type=template&id=3b635b6b&scoped=true"
import script from "./shouhufooter.vue?vue&type=script&lang=js"
export * from "./shouhufooter.vue?vue&type=script&lang=js"
import style0 from "./shouhufooter.vue?vue&type=style&index=0&id=3b635b6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b635b6b",
  null
  
)

export default component.exports